import "./styles.less";

import { Col, Skeleton, Typography, Button } from "antd";
import { ProjectInfoItem, ProjectInfoType, useProjectInfo } from "./hook";
import { useEffect, useState } from "react";

import { List } from "antd";
import { useFacebookPixel } from "shared-components/GlobalHooks/web/FacebookPixel.hook";
import { useRouter } from "next/router";

type ProjectInfoProps = ProjectInfoType & { loading?: boolean; projectId: string };

export const ProjectInfo = ({ loading = false, projectId, ...rest }: ProjectInfoProps) => {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const { query } = useRouter();
	const { projectInfoList, sendLead, formCompleted } = useProjectInfo(projectId, rest, query);
	const [asked, setAsked] = useState([]);
	const FP = useFacebookPixel();

	useEffect(() => {
		if (formCompleted) {
			FP.StandardEvent("CompleteRegistration");
		}
	}, [formCompleted]);

	if (loading) {
		return <Skeleton active />;
	}

	if (!projectInfoList.length) {
		return null;
	}

	const SpanAskFast = ({ field }) => {
		if (asked.some(o => o == field)) {
			return <Typography.Text disabled>{"¡Preguntado!"}</Typography.Text>;
		} else {
			return (
				<Button
					type="text"
					ghost={true}
					onClick={() => askFastAction(field)}
					className="btnQuestion"
				>
					{"¡Preguntale!"}
				</Button>
			);
		}
	};

	const askFastAction = field => {
		sendLead(field)
			.then(res => {
				if (res) {
					setAsked([...asked, field]);
					handleClickShowNotification({ message: "¡Consulta express enviada con éxito!" });
				}
			})
			.catch(error => {
				console.log(error);
			});
	};

	const ProjectInfoItem = ({ title, value, key }: ProjectInfoItem) => (
		<List.Item>
			<Col span={12}>
				<b>{title}</b>
			</Col>
			<Col span={12}>{value ? value : <SpanAskFast field={key} />}</Col>
		</List.Item>
	);

	return (
		<List
			size="small"
			bordered
			className="project-info"
			dataSource={projectInfoList}
			renderItem={ProjectInfoItem}
		/>
	);
};
